module.exports = __webpack_public_path__ + "static/media/user_experience.523795ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user_experience.svg
// module id = 460
// module chunks = 0